import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <Box
      id="contact"
      sx={{
        py: 12,
        background: 'linear-gradient(180deg, #0a192f 0%, #020c1b 100%)',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div variants={itemVariants}>
            <Typography variant="h2" color="primary" sx={{ mb: 4, textAlign: 'center' }}>
              {t('contact.title')}
            </Typography>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 6, textAlign: 'center' }}>
              {t('contact.description')}
            </Typography>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                background: 'rgba(144, 202, 249, 0.08)',
                borderRadius: 2,
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'rgba(144, 202, 249, 0.15)',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
                {t('contact.emailTitle')}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                href="mailto:melihsahakin@gmail.com"
                startIcon={<EmailIcon />}
                sx={{ 
                  textTransform: 'none',
                  fontSize: '1.1rem'
                }}
              >
                melihsahakin@gmail.com
              </Button>
            </Paper>
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Contact;
